import { Component, Prop, Watch } from 'vue-property-decorator';
import { TicketViewmodel } from './ticket.viewmodel';
import { namespace } from 'vuex-class';
import { SEARCH_AUTOCOMPLETE, SEARCH_MODULE_NAMESPACE, SEARCH_REQUEST_BYKEYS_FORCE } from '../../../../store/search';
import { BLOCK_GET_BLOCKS, BLOCK_MODULE_NAMESPACE, GET_BLOCKS_BY_TETANT } from '../../../../store/block';
import { IBlock, IBlockListingViewModel, IBlockParameter } from '../../../../models/block';
import {
  APARTMENT_GET_APPARTMENTS_AUTOCOMPLETE,
  APARTMENT_GET_BLOCK_APPARTMENTS_AUTOCOMPLETE,
  APARTMENT_MODULE_NAMESPACE, APARTMENT_SEARCH_ZONE
} from '../../../../store/apartment';
import { SearchEntities, TicketTypes, UserTemplate, UserTypes } from '../../../../common/enums';
import { TENANT_GET_BLOCK_TENANTS, TENANT_GET_TENANTS, TENANT_MODULE_NAMESPACE } from '../../../../store/tenant';
import { USER_MODULE_NAMESPACE } from '../../../../store/user/user-types.store';
import { IUserDetails } from '../../../../models/user';
import { isNullOrUndefined } from 'util';
import { IApartmentListingViewModel } from '../../../../models/apartment';
import {
  TICKET_GET_EQUIPMENT,
  TICKET_GET_TICKET_PRIORITY_LEVEL,
  TICKET_GET_TICKET_SUBSTATUS,
  TICKET_MODULE_NAMESPACE
} from '../../../../store/ticket';
import { ITicketListingViewModel } from '../../../../models/ticket';
import { SERIVCEBOOK_MODULE_NAMESPACE } from '../../../../store/service-book';
import { IServiceBookDetails } from '../../../../store/service-book/service-book-state.store';

const SearchStore = namespace(SEARCH_MODULE_NAMESPACE);
const BlockStore = namespace(BLOCK_MODULE_NAMESPACE);
const TenantStore = namespace(TENANT_MODULE_NAMESPACE);
const ApartmentStore = namespace(APARTMENT_MODULE_NAMESPACE);
const UserStore = namespace(USER_MODULE_NAMESPACE);
const TicketStore = namespace(TICKET_MODULE_NAMESPACE)
const ServiceBookStore = namespace(SERIVCEBOOK_MODULE_NAMESPACE)

interface IRoundButton {
  key: string;
  value: number | boolean | string;
  translationKey: string;
}

@Component({
  components: {
    'ticket-nature-problem': async () => import('../ticket-modal-nature-of-problem/TicketModalNatureOfProblem.vue'),
    'ticket-upload-buttons-new': async () => import('../ticket-modal-upload-buttons-new/TicketUploadButtonsNew.vue'),
    'ticket-group-round-buttons': async () => import('../ticket-modal-group-round-buttons/TicketModalGroupRoundButtons.vue'),
    'ticket-origin-demand': async () => import('../ticket-modal-origin-demand/TicketModalOriginDemand.vue'),
    'ticket-mandate-selector': async () => import('../ticket-mandate-selector/TicketMandateSelector.vue'),
    'mandate-quote-selector': async () => import('../ticket-mandate-or-quote-selector/TicketMandateOrQuoteSelector.vue')
  }
})
class TicketModalVertical extends TicketViewmodel {

  private _clearTimeout: any;
  private dtIsManagerOrContractor: boolean;
  private dtApartments: IApartmentListingViewModel[]
  private dtBlocks: any[]
  private dtZones: any[]
  private dtAttachmentCreator: any;
  private dtExcludeBlock: boolean;
  private readonly participantToSearch: SearchEntities[];

  private dtApartmentLoading: boolean;
  dtRules: {
    ticketDeclarerRules?: any
    nameRules?: any
    ticketFkTicketBlockRules?: any
    ticketFkTicketApartmentRules?: any
    ticketFkTicketTenantRules?: any
    descriptionRules?: any;
    ticketFkTicketCharacterProblemsRules?: any;
    ticketFkTicketCharacterProblemsRules_1?: any;
    ticketFkTicketCharacterProblemsRules_2?: any;
    ticketFkTicketEquipmentRules?: any;
    ticketFkTicketManagerRules?: any;
    ticketFkTicketPriorityLevelRules?: any;
    ticketVehicleMileageRules?: any
    ticketVehicleAvailability?: any
  }

  showMileageAvailability: boolean

  /**
   *
   */
  constructor() {
    super();
    this.dtRules = {};
    this.dtIsManagerOrContractor = false;
    this.dtApartments = [];
    this.dtBlocks = null;
    this.dtZones = [];
    this.dtAttachmentCreator = null;
    this.dtApartmentLoading = false;
    this.dtExcludeBlock = false
    this.participantToSearch = [
      SearchEntities.Tenant,
      SearchEntities.CareTaker,
      SearchEntities.Manager,
      SearchEntities.Owner,
      SearchEntities.Salesperson
    ];
    this.showMileageAvailability = false
  }

  @ServiceBookStore.Getter currentServiceBook:IServiceBookDetails

  @UserStore.Getter userInfo: IUserDetails;
  @UserStore.Getter isTenantAndOwner: boolean;
  @SearchStore.Getter contractors: any[];
  @SearchStore.Getter managers: any[];
  @SearchStore.Getter caretakers: any[];
  @BlockStore.Getter blocks: any[];
  @BlockStore.Getter currentBlock: any;
  @TenantStore.Getter tenants: any[];
  @ApartmentStore.Getter apartments: any[];
  @TicketStore.Getter currentTicket: ITicketListingViewModel;
  @TicketStore.Getter ticketPriorityLevels: { name: string, id: number }[]
  @TicketStore.Getter ticketSubstatus: { name: string, id: number }[]
  @TicketStore.Getter ticketProblemType: any[]

  @SearchStore.Action(SEARCH_REQUEST_BYKEYS_FORCE)
  storeGetMasterData: (payload?: { keys: SearchEntities[] }) => Promise<any>;

  @SearchStore.Action(SEARCH_AUTOCOMPLETE)
  storeGetDeclarants: (payload: { query }) => Promise<any>;

  @TicketStore.Action(TICKET_GET_EQUIPMENT)
  storeGetEquipments: (params: any) => Promise<any>;

  @BlockStore.Action(BLOCK_GET_BLOCKS)
  storeGetBlocks: (payload: { param: IBlockParameter, merge?: boolean }) => Promise<any>;
  @BlockStore.Action(GET_BLOCKS_BY_TETANT)
  storeGetBlocksByTenantId: (tenantId: number) => Promise<any>;

  @SearchStore.Action(SEARCH_AUTOCOMPLETE)
  storeGetTenantsSearch: (payload: { entity?: SearchEntities | SearchEntities[], query: string }) => Promise<any>;

  @SearchStore.Action(SEARCH_AUTOCOMPLETE)
  storeGetEntitySearch: (payload: {
    entity?: SearchEntities | SearchEntities[], query?: string, limit?: number,
    apartment?: number[], block?: number[]
  }) => Promise<any>;

  @TenantStore.Action(TENANT_GET_TENANTS)
  storeGetTenants: (param: any) => Promise<any>;
  @TenantStore.Action(TENANT_GET_BLOCK_TENANTS)
  storeGetBlockTenants: (payload: { param: any, blockId: string | number }) => Promise<any>;

  @TicketStore.Action(TICKET_GET_TICKET_PRIORITY_LEVEL)
  storeGetTicketPriorityLevel: () => void;


  // @ApartmentStore.Action(APARTMENT_GET_APPARTMENTS)
  // storeGetAppartments: (payload: { param?: any, blockId: string }) => Promise<any>;
  @ApartmentStore.Action(APARTMENT_GET_APPARTMENTS_AUTOCOMPLETE)
  storeGetApartmentsAutocomplete: (payload: { blockId?: number, entity?: number[], key?: string, limit?: number, external?: boolean }) => Promise<any>;
  @ApartmentStore.Action(APARTMENT_GET_BLOCK_APPARTMENTS_AUTOCOMPLETE)
  storeGetBlockApartmentsAutocomplete: (payload: { blockId?: string, entity?: string, key?: string }) => Promise<any>;
  @ApartmentStore.Action(APARTMENT_SEARCH_ZONE)
  storeSearchApt: (payload: { apartments: number[], q: string }) => Promise<any>;

  @Prop({ default: () => [], type: [Array] })
  attachments: any[];
  @Prop({ default: () => [], type: [Array] })
  declarants: any[];
  @Prop({ default: () => null, type: [Object] })
  currentTenant: any;

  @Prop({ default: false, type: [Boolean] })
  toUpdate: boolean


  @Watch('FKTicketCharacterProblem')
  CharacterProblemChanged(value) {
    /* const charProblem = this.characterProblems.level_1
    const charProblemValue = charProblem.find(item=>item.id===value)
    console.log('FKTicketCharacterProblem : ',value)
    console.log('CharProblem : ',this.characterProblems.level_1)
    console.log(charProblemValue)
    if(charProblemValue.name === 'Véhicule'){} */
    if (value === 238) // 'Véhicule'
    {
      this.showMileageAvailability = true
    } else {
      this.mileage = null
      this.availability = null
      this.showMileageAvailability = false
    }
  }

  get isServiceBookUser():boolean {
    return this.userInfo.template !== UserTemplate.default
  }

  get vAttachments() {
    return this.attachments
  }

  set vAttachments(value) {
    this.$emit('update:attachments', value);
  }

  get lblSetting() {
    return {
      ...require('@/locales/ticket').default,
      ...require('@/locales/validation-messages').default,
      ...require('@/locales/generic-labels').default,
    }
  }

  get textConfigs() {
    return require("@/assets/json-resources/text-field-configs.json")
  }

  get isInternalProblem() {
    return this.toUpdate && this.currentTicket.pb_type && this.currentTicket.pb_type.toLowerCase() === 'internal'
  }

  get typesOfTheProblems(): IRoundButton[] {

    let agencyPbTypes = (this.ticketProblemType).map(x => {
      return { ...x }
    })

    agencyPbTypes = agencyPbTypes.filter(x => x.key !== TicketTypes.Maintenance)

    if (!this.$route.meta.internal_problem_type) {
      agencyPbTypes = agencyPbTypes.filter(x => x.key !== TicketTypes.Internal)
    }

    if (!this.dtIsManagerOrContractor) {
      agencyPbTypes = agencyPbTypes.filter(x => x.key !== TicketTypes.Internal)
    }

    return (agencyPbTypes || []).map(x => {
      return { key: x.key, translationKey: x.name, value: x.key }
    })
  }

  get displayTypesOfProblem(): boolean {
    return this.typesOfTheProblems.length > 1
  }

  get characterProblems2() {
    if (this.$route.meta.char_pb_linked) {
      if (!this.FKTicketCharacterProblem) return []
      return this.characterProblems.level_1.find(x => x.id === this.FKTicketCharacterProblem).level_2
    }
    return this.characterProblems.level_2
  }

  get equipmentsToDisplay() {
    if (!this.equipments) return []
    return this.equipments.map(x => {
      x.fullname = x.name
      if (x.reference)
        x.fullname += ' (' + x.reference + ')'
      return x
    })
  }

  get coEquipments() {
    let equipments = this.toUpdate ? this.equipments.concat(this.currentTicket.equipments) : this.equipments;
    return (this.dtEquipments || []).concat(equipments || []).map(x => {
      x.firstname = x.name
      x.lastname = x.reference ? '(' + x.reference + ')' : ''
      return x
    })
  }

  get notifyTheOwners(): IRoundButton[] {
    return [
      { key: 'OUI', translationKey: 'OUI', value: true },
      { key: 'NON', translationKey: 'NON', value: false },]
  }

  get addASpeakers(): IRoundButton[] {
    return [
      { key: 'DEVIS', translationKey: 'DEVIS', value: false },
      { key: 'MANDATER', translationKey: 'MANDATER', value: true },]
  }

  /*get coDeclarantInt(): number | null {
    return this.Creator
  }*/

  get coDeclarant() {
    return [this.userInfo]
      .concat(this.dtTemporaryParticipants)
      .concat(this.currentTicket.declarant || []).filter(x => !!x);
  }

  get coTenants() {
    return this.dtTemporaryTenants;
  }

  get coParticipants() {
    return this.dtTemporaryParticipants;
  }

  get coBlocks() {
    let dtBlocks = (this.dtBlocks || this.blocks || [])
    if ((this.ticket.fk_ticket_block && this.currentTicket.block) && (this.ticket.fk_ticket_block === this.currentTicket.block.id) && dtBlocks.findIndex(x => x.id === this.ticket.fk_ticket_block) === -1) {
      dtBlocks = dtBlocks.concat([this.currentTicket.block])
    }
    const blocks = dtBlocks.map(
      (b: IBlock) => this.mapBlockToOptions(b).next().value);
    if (this.$route.path.indexOf('block')) {
      const blockId: number = Number(this.$route.params.id);
      if (blockId > 0) {
        const currentBlock: any[] = blocks.filter((x: any) => x.value === blockId);
        if (currentBlock.length === 0) {
          blocks.unshift(this.mapBlockToOptions(this.currentBlock).next().value)
        }
      }
    }
    return blocks.filter((x: any) => x.value !== undefined);
  }

  get coApartments() {
    if(this.toUpdate){
      this.dtApartments = this.currentTicket.apartments
       return (this.dtApartments || []).map(x => ({
      value: x.id,
      text: x['apartment_number']
    }));
    }
    return (this.dtApartments || []).map(x => ({
      value: x.apartment.id,
      text: x.apartment['location_number'] ? x.apartment['location_number'] + ' / ' + x.apartment['apartment_number'] : x.apartment['apartment_number'],
      ...x
    }));
  }

  get coZones() {
    return (this.dtZones || []).map(x => ({
      value: x.id,
      text: x.name,
      ...x
    }))
  }

  get coManagers() {
    return [...(this.managers || []), ...this.dtAssignedMe];
  }

  get coIsManager(): boolean {
    return this.userInfo.type === UserTypes.Manager;
  }

  get coIsAssigned(): boolean {
    return this.Managers.filter(id => id === this.userInfo.id).length > 0
  }

  get coIsPrivate(): boolean {
    return this.pbType === TicketTypes.Private || this.userInfo.type === UserTypes.Tenant;
  }

  get apartmentRules() {
    if (this.pbType === TicketTypes.Private)
      return this.dtRules.ticketFkTicketApartmentRules
    else return undefined
  }

  get equipmentRules() {
    if (this.$route.meta.equipment_required) {
      return this.dtRules.ticketFkTicketEquipmentRules
    }
    return undefined
  }

  get coTicketPriorityLevels() {
    return this.ticketPriorityLevels;
  }

  get coTicketSubstatus() {
    return this.ticketSubstatus;
  }

  /*get ownerVisible() {
    return this.contractors && this.$route.meta.warn_owner
      && this.pbType !== TicketTypes.Public
  }*/

  get hadBlock() {
    return typeof this.FkTicketBlock === "number" && this.FkTicketBlock > 0
  }

  get hadApartment() {
    return (this.TicketApartments || []).length > 0
  }

  get excludeBlock() {
    return this.dtExcludeBlock
  }

  set excludeBlock(value: boolean) {
    this.appartmentSwitcherHandler()
  }


  handleGetDeclarants(query: string) {
    //return this.storeGetDeclarants({ query })
    //return this.storeGetEntitySearch({entity: this.participantToSearch, query: query})
    if (!this.$route.meta.add_tenant)
      return [];
    return this.storeGetEntitySearch({
      entity: SearchEntities.Participant, query: query,
      limit: 50, apartment: this.pbType === TicketTypes.Private ? this.TicketApartments : null,
      block: this.hadBlock ? [this.FkTicketBlock] : null
    })
  }

  /*handleGetTenants(query: string) {
    if (this.$route.fullPath.indexOf('ticket') > -1) {
      return this.storeGetTenantsSearch({entity: SearchEntities.Tenant, query: query})
    } else {
      if (this.$route.path.indexOf('tenant') > -1) {
        return Promise.resolve([this.currentTenant.tenants.find(x => x.id === Number(this.$route.params.cid))])
      } else if (this.$route.path.indexOf('owner') > -1) {
        return Promise.resolve([this.currentTenant.owners.find(x => x.id === Number(this.$route.params.cid))])
      }
      return Promise.resolve([])
    }
  }*/

  handleGetParticipants(query: string) {
    return this.storeGetEntitySearch({
      entity: SearchEntities.Participant, query: query,
      limit: 50, apartment: this.pbType === TicketTypes.Private ? this.TicketApartments : null,
      block: this.hadBlock ? [this.FkTicketBlock] : null
    })
  }

  * mapBlockToOptions(block: IBlock) {
    yield { text: block.name, firstname: block.name, lastname: '', value: block.id };
  }

  get isServiceBook():boolean {
    return this.$route.path.includes('service-book')
  }

  mounted() {
    // === service book
    if(this.isServiceBook)
    {
      this.FkTicketBlock = this.currentServiceBook.apartment.fk_apartment_block
      this.TicketApartments = [this.currentServiceBook.apartment.id]
    }


    if (this.toUpdate && this.FKTicketCharacterProblem === 238) {
      let availabilityMileage = this.currentTicket.ticket_availability_mileage ? true: false
      this.mileage = availabilityMileage ? this.currentTicket.ticket_availability_mileage.mileage : null
      this.availability = availabilityMileage ?  this.currentTicket.ticket_availability_mileage.availability : null
    }
    if (this.FKTicketCharacterProblem === 238) { this.showMileageAvailability = true }

    this.storeGetMasterData({
      keys:
        [
          SearchEntities.Contractor,
          SearchEntities.Manager,
          SearchEntities.CareTaker
        ]
    }).catch(error => console.log(error));
    this.$nextTick(() => {
      const param: any = {};
      if (this.$route.path.indexOf('tenant') > -1 || this.$route.path.indexOf('owner') > -1) {
        param.entity = this.$route.params.cid;
        if (this.$route.path.indexOf('tenant') > -1) {
          const tenant = this.currentTenant.tenants.find(x => x.id === Number(this.$route.params.cid))
          if (tenant) {
            //this.dtTemporaryTenants = [tenant];
            this.dtTemporaryParticipants = [tenant];
            //this.pbType = TicketTypes.Private
          }
        }
      }
      if (this.$route.fullPath.indexOf('apartment') > -1) {
        //this.pbType = TicketTypes.Private
      }
      this.storeGetBlocks({ param: param, merge: false })
      //this.storeGetTenants({}).catch(res => console.log(res)).catch(error => console.log(error))
      if (this.$route.meta.add_tenant) {
        this.storeGetEntitySearch(
          {
            entity: SearchEntities.Participant,
            block: [this.FkTicketBlock],
            apartment: this.TicketApartments,
            query: ''
          })
          .then(res => {
            this.dtTemporaryParticipants = res
          })
      }
      this.handleApartmentByBlockAndEntities().then(() => {
        this.getEquipmentByParams(false)
        this.handleFillZone()
      })
      if (this.ticketPriorityLevels.length === 0) this.storeGetTicketPriorityLevel()
    })


    this.dtIsMandate = this.ticket.mandates && this.ticket.mandates.length > 0;
    this.dtIsNotifyOwner = this.ticket.mandates && this.ticket.mandates.length > 0;

    this.dtRules = {
      ticketDeclarerRules: [(v) => !!v || this.$t(this.lblSetting.declarererRequired)],
      ticketFkTicketBlockRules: [(v) => (!!v && v > 0) || this.$t(this.lblSetting.blockRequired)],
      ticketFkTicketApartmentRules: [(v) => (!!v && v.length > 0) || this.$t(this.lblSetting.apartmentRequired)],
      ticketFkTicketTenantRules: [(v) => !!v && (v > 0 || v.id > 0) || this.$t(this.lblSetting.declarererRequired)],
      ticketFkTicketManagerRules: [(v) => !!v && v.length > 0 || this.$t(this.lblSetting.managerRequired)],
      ticketFkTicketCharacterProblemsRules: [(v) => !!v || `${this.$t(this.lblSetting.ticketNatureOfTheProblem)} ${this.$t(this.lblSetting.declarererRequired)}`],
      ticketFkTicketCharacterProblemsRules_1: [(v) => !!v || `${this.$t(this.lblSetting.characterProblemRequired)}`],
      ticketFkTicketCharacterProblemsRules_2: [(v) => !!v || `${this.$t(this.lblSetting.characterProblemRequired)} 2`],
      ticketFkTicketEquipmentRules: [(v) => !!v || `${this.$t(this.lblSetting.equipmentRequired)}`],
      ticketFkTicketPriorityLevelRules: [(v) => !!v || this.$t(this.lblSetting.ticketPriorityLevelRequired)],
      nameRules: [
        v => !!v || this.$t(this.lblSetting.emptyRequired, { type: this.$t(this.lblSetting.lblTicketName) }),
        v => (!!v && v.length >= 3) || this.$t(this.lblSetting.ticketMinNameLength)
      ],
      descriptionRules: [
        v => !!v || this.$t(this.lblSetting.emptyRequired, { type: 'Description', f: 'e' })
      ],
      ticketVehicleMileageRules: [(v) => !!v || this.$t(this.lblSetting.emptyRequired, { type: this.$t(this.lblSetting.ticketVehicleMileage) })],
      ticketVehicleAvailability: [(v) => !!v || this.$t(this.lblSetting.emptyRequired, { type: this.$t(this.lblSetting.ticketVehicleAvailability) })]
    }
    if (!this.$route.meta.char_pb_2_required) {
      this.dtRules.ticketFkTicketCharacterProblemsRules_2 = [(v) => true]
    }
    if (!this.$route.meta.char_pb_1_required) {
      this.dtRules.ticketFkTicketCharacterProblemsRules_1 = [(v) => true]
    }

    if (this.userInfo.type === UserTypes.Tenant) {
      this.dtCurrentTenant = JSON.parse(JSON.stringify(this.userInfo));
    }

    if (this.Declarant) {
      this.dtIsManagerOrContractor = this.checkUserTypePermission(this.userInfo.role)
    }

    if (this.$route.meta.assign_manager) {
      if (this.currentBlock.id) {
        this.handleChangeBlock(this.currentBlock.id).then()
      }
    }
    //this.pbType = this.ticketProblemType[0].key
    this.pbType = this.ticketProblemType.filter(x => x.key !== TicketTypes.Maintenance)[0].key
    if (this.toUpdate) {
      this.pbType = this.currentTicket.pb_type
    }
    if (!this.$route.meta.report_description_required) {
      this.dtRules.descriptionRules = [(v) => true]
    }
  }

  handleAssignMe() {
    clearTimeout(this._clearTimeout);
    this._clearTimeout = setTimeout(() => {
      if (this.coIsAssigned)
        return;
      this.dtAssignedMe = [{
        id: this.userInfo.id,
        firstname: this.userInfo.firstname,
        lastname: this.userInfo.lastname
      }];
      this.storeAssignMe(this.userInfo.id);
    }, 300);
  }

  /*async bindTenantDefaultData(event: any) {
    this.dtCurrentTenant = event;
    if (event.blocks && event.blocks.length) {
      const blocksExisted: IBlockListingViewModel[] = event.blocks.filter(x => x.id === this.FkTicketBlock);
      if (blocksExisted.length === 0) {
        this.FkTicketBlock = event.blocks.map(x => x.id)[0];
        this.dtBlocks = event.blocks;
      }
    }
    if (event.apartments) {
      this.dtApartments = event.apartments.map(x => ({...x, apartment: x}));
      if (event.apartments.length) {
        this.FkTicketApartment = event.apartments.map(x => x.id)[0]; //Adapt with new response DRIV-1210
        this.TicketApartments = event.apartments.map(x => x.id);
      }
    } else if (this.FkTicketApartment === undefined) {
      this.FkTicketApartment = this.dtApartments.map(x => x.id)[0]; //Adapt with new response DRIV-1210
      this.TicketApartments = this.dtApartments.map(x => x.id);
    }
  }*/

  /*async bindTenantIntoCreator(event) {
    //this.dtTemporaryTenants = [event];
    //this.dtTemporaryParticipants = [event];
    //this.Tenants = this.Creator;
  }*/

  async handleChangeDeclarant(event?) {
    // if component return id instead of object (unused)
    if (typeof event === 'number') {
      // this.storeGetBlocks({ param: { entity: [event] }, merge: false })
      return;
      // This selector must return an object not an array
    } else if (event && !Array.isArray(event) && typeof event === 'object') {
      this.dtAttachmentCreator = event; //Sending and displaying creator of attachment
      if (event.type !== SearchEntities.Manager) {
        await this.storeGetBlocks({ param: { entity: [event.id] }, merge: false })
          .then(blocksDeclarant => {
            const blocksExisted: IBlockListingViewModel[] = blocksDeclarant.filter(x => x.id === this.FkTicketBlock);
            if (blocksExisted.length === 0) {
              this.FkTicketBlock = blocksDeclarant.map(x => x.id)[0];
              this.dtBlocks = blocksDeclarant;
              this.handleChangeBlock(blocksDeclarant.map(x => x.id)[0])
              //this.getEquipmentByParams()
            }
            this.handleApartmentByBlockAndEntities()
          })
      } else {
        this.handleApartmentByBlockAndEntities()
      }
      this.dtIsManagerOrContractor = this.checkUserTypePermission(event.type);
      if (this.dtIsManagerOrContractor) {
        // this.pbType = TicketTypes.Internal; Comment because receive new change request from Benjamin 01/03/2019 by call
        /*this.dtCurrentTenant = null;
        this.dtTemporaryTenants = [];
        this.Tenants = null;*/
      } else if (event.type !== UserTypes.SalesPerson) {
        this.pbType = this.pbTypeDefaultCase(TicketTypes.Private) ? TicketTypes.Private : this.typesOfTheProblems[0].key;
        this.preselectTenantsOfApartment()
        this.handlePbTypeChange(null);
        //this.bindTenantDefaultData(event);
        //this.bindTenantIntoCreator(event);
      }
      if (!this.$route.meta.select_ticket_pb_type) {
        this.pbType = this.pbTypeDefaultCase(TicketTypes.Public) ? TicketTypes.Public : this.typesOfTheProblems[0].key;
      }
    }
    if (isNullOrUndefined(this.Declarant)) {
      console.log('isNullOrUndefined ==============')
      this.dtIsManagerOrContractor = false;
      this.pbType = this.pbTypeDefaultCase(TicketTypes.Public) ? TicketTypes.Public : this.typesOfTheProblems[0].key;
      this.dtAttachmentCreator = null;
    }
  }


  /*async handleChangeTenant(event?) {
    clearTimeout(this._clearTimeout)
    this._clearTimeout = setTimeout(async () => {
      if (event && !Array.isArray(event) && typeof event === 'object') {
        this.pbType = TicketTypes.Private;
        await this.storeGetBlocksByTenantId(event.id)
          .then(response => {
            //this.bindTenantDefaultData({...event, ...response})
          })
          .catch(error => console.log(error, 'error'))
        return;
      } else if (typeof event === "number") {
        await this.storeGetBlocksByTenantId(event)
          .then(response => {
            const blocksExisted: IBlockListingViewModel[] = response.blocks.filter(x => x.id === this.FkTicketBlock);
            if (blocksExisted.length === 0 && response.blocks.length > 0) {
              this.FkTicketBlock = response.blocks[0].id
            }

          })
          .catch(error => console.log(error, 'error'))
        return;
      }
      if (event === undefined) {
        const declarant = this.coDeclarant.find(x => x.id === this.Creator);
        if (declarant && (declarant.type === SearchEntities.Tenant || declarant.type === SearchEntities.Owner)) {
          this.dtIsManagerOrContractor = false;
        }
        this.dtBlocks = null;
      }
    }, 100);
  }*/

  async handleChangeParticipants(event?) {
    clearTimeout(this._clearTimeout)
    this._clearTimeout = setTimeout(async () => {

      await this.handleApartmentByBlockAndEntities()
      /*if (event && Array.isArray(event)) {
        let participantOwnerOrTenant = event.filter(participant => participant.type === SearchEntities.Tenant || participant.type === SearchEntities.Owner)
        if (participantOwnerOrTenant.length === 1) {
          // First owner or tenant participant
          const declarant = this.coDeclarant.find(x => x.id === this.Creator);
          if (declarant && (declarant.type === SearchEntities.Tenant || declarant.type === SearchEntities.Owner)) {

          }
        }
      }*/
      /*if (event && !Array.isArray(event) && typeof event === 'object') {
        this.pbType = TicketTypes.Private;
        await this.storeGetBlocksByTenantId(event.id)
          .then(response => {
            this.bindTenantDefaultData({...event, ...response})
          })
          .catch(error => console.log(error, 'error'))
        return;
      } else if (typeof event === "number") {
        await this.storeGetBlocksByTenantId(event)
          .then(response => {
            const blocksExisted: IBlockListingViewModel[] = response.blocks.filter(x => x.id === this.FkTicketBlock);
            if (blocksExisted.length === 0 && response.blocks.length > 0) {
              this.FkTicketBlock = response.blocks[0].id
            }

          })
          .catch(error => console.log(error, 'error'))
        return;
      }*/
      /*if (event === undefined) {
        const declarant = this.coDeclarant.find(x => x.id === this.Creator);
        if (declarant && (declarant.type === SearchEntities.Tenant || declarant.type === SearchEntities.Owner)) {
          this.dtIsManagerOrContractor = false;
        }
        this.dtBlocks = null;
      }*/
    }, 100);
  }

  async handleChangeBlock(blockId: any) {
    //this.removeDeclarantTenantOwner()
    //this.Participants = []
    //this.dtTemporaryParticipants = []
    this.TicketApartments = []
    await this.handleParticipantsDeclarantByBlockAndApartment().finally(async () => {
      await this.handleApartmentByBlockAndEntities()
    })
    this.Managers = []
    if (!this.hadBlock) {
      //this.TicketApartments = []
      //this.dtApartments = []
      return;
    } else {
      /* OLD CODE
      if (blockId === undefined) {
        this.dtApartments = [];
        return;
      } else if (blockId > 0) {
      */
      if (this.$route.meta.assign_manager) {
        await this.storeGetEntitySearch({ entity: SearchEntities.Manager, limit: 50, block: [blockId] })
          .then(res => {
            let managers = res.filter(manager => (this.Managers.findIndex(x => x === manager.id) === -1))
            if (managers.length > 0) {
              this.Managers = this.Managers.concat(managers.map(manager => manager.id))
            }
          })

      }
      /*if (!this.Tenants) {
        await this.storeGetBlockTenants({param: {}, blockId})
          .then(res => {
            //this.dtTemporaryTenants = res.data;
            this.dtTemporaryParticipants = res.data;
            //if (this.Tenants && typeof this.Tenants === 'object') {
              //if (res.data.filter(x => x.id === (this.Tenants as any).id).length > 0)
                //return;
            //}
            if (res.data.length === 1)
              this.Tenants = res.data[0].id;
          })
          .catch(res => {
            console.log((res))
          })
      }*/
    }
    this.getEquipmentByParams()
    this.handleFillZone()
  }

  async appartmentSwitcherHandler() {
    this.dtExcludeBlock = !this.dtExcludeBlock
    await this.handleApartmentByBlockAndEntities()
  }

  async handleChangeApartment(value) {
    await this.handleParticipantsDeclarantByBlockAndApartment()
    if (value && value.length === 1) {
      let apartment = (this.dtApartments || []).filter(x => x.id === value[0])
      if (apartment.length === 1) {
        if (apartment[0].block && apartment[0].block.id !== this.FkTicketBlock) {
          this.FkTicketBlock = apartment[0].block.id
          if (this.coBlocks.findIndex((x: any) => x.value === apartment[0].block.id) === -1) {
            this.dtBlocks = [apartment[0].block]
          }
        }
      } else {
        console.error("Can't get appartment from Store list")
      }
    }
    this.getEquipmentByParams()
    this.handleFillZone()
  }

  async handleChangeZone(value) {

  }

  handleChangeCharPb1(value) {
    this.FKTicketCharacterProblem2 = null
    this.getEquipmentByParams()
  }

  handleChangeCharPb2(value) {
    this.getEquipmentByParams()
  }

  handleRemoveCharPb1() {
    this.FKTicketCharacterProblem = null
    this.FKTicketCharacterProblem2 = null
    this.getEquipmentByParams()
  }

  handleRemoveCharPb2() {
    this.FKTicketCharacterProblem2 = null
    this.getEquipmentByParams()
  }

  handleChangeEquipment(value) {
    if (value.length === 1) {
      let eqp = this.equipments.find(x => x.id === value[0])
      if (!this.FKTicketCharacterProblem || !this.FKTicketCharacterProblem2 ||
        (this.$route.meta.equipment_preselect_apartment && (!this.TicketApartments || this.TicketApartments.length === 0))) {
        this.FKTicketCharacterProblem = eqp.fk_character_problem_lvl1
        this.FKTicketCharacterProblem2 = eqp.fk_character_problem_lvl2
        if (eqp.fk_equipment_apartment)
          this.TicketApartments = [eqp.fk_equipment_apartment]
        this.getEquipmentByParams(false)
      }
    }
  }

  async handleApartmentByBlockAndEntities() {

    if(this.toUpdate){
      return new Promise((resolve) => {
        resolve(null)
      })
    }
    let payload: { blockId?: number, entity?: number[], key?: string, limit?: number, external?: boolean } = {}
    if (this.FkTicketBlock && !this.dtExcludeBlock) { payload.blockId = this.FkTicketBlock }
    if (this.dtExcludeBlock) { payload.external = true }

    payload.limit = 50
    /*if (this.Tenants) {
      if (!Array.isArray(this.Tenants)) {
        if (typeof this.Tenants === "number") {
          condition.entity = this.Tenants
        } else if (typeof this.Tenants === 'object') {
          condition.entity = (this.Tenants as any).id
        }
      }
    }*/
    // if ticket is private
    this.dtApartmentLoading = true;
    payload = this.fillPayloadEntityOwnerTenantForPrivateTicket(payload)
    return this.storeGetApartmentsAutocomplete(payload)
      .then(res => {
        this.dtApartments = res.map(x => ({ ...x, apartment: x }));
        let apartmentNotInclude = this.TicketApartments.filter(x => this.dtApartments.findIndex(apt => apt.id === x) === -1)
        if (apartmentNotInclude.length > 0)
          this.TicketApartments = this.TicketApartments.filter(x => this.dtApartments.findIndex(apt => apt.id === x) > -1)

        this.dtApartmentLoading = false;
        if (this.pbType !== TicketTypes.Public) {
          if (this.$route.fullPath.indexOf('apartment') > -1) {
            //this.FkTicketApartment = Number(this.$route.params.cid)
            this.TicketApartments = [Number(this.$route.params.cid)]
          } else {
            if (this.dtApartments.length === 1) {
              //this.FkTicketApartment = this.dtApartments[0].id
              if (!this.TicketApartments || this.TicketApartments.length === 0) {
                this.TicketApartments = this.dtApartments.map(x => x.id)
                this.FkTicketBlock = (this.dtApartments[0] as any).fk_apartment_block
              } else if (this.TicketApartments[0] !== this.dtApartments[0].id) {
                this.TicketApartments = this.dtApartments.map(x => x.id)
              }
            }
          }
        }
        return Promise.resolve(res)
      })
      .catch(err => {
        this.dtApartmentLoading = false;
        return Promise.reject(err)
      })
  }

  async handleParticipantsDeclarantByBlockAndApartment() {
    let payload = {
      entity: SearchEntities.Participant, query: '',
      limit: 100, apartment: this.pbType === TicketTypes.Private ? this.TicketApartments : null,
      block: this.hadBlock ? [this.FkTicketBlock] : null
    }

    if (!this.$route.meta.add_tenant) {
      return [];
    }


    if (this.dtExcludeBlock === true) {
      delete payload.apartment
    }


    return this.storeGetEntitySearch(payload).then(res => {
      this.dtTemporaryParticipants = res
      if (this.Participants && this.Participants.length > 0) {
        let participantNotInData = this.Participants.filter(x => this.dtTemporaryParticipants.findIndex(p => p.id === x.id) === -1)
        if (participantNotInData.length > 0) {
          this.Participants = this.Participants.filter(x => this.dtTemporaryParticipants.findIndex(p => p.id === x.id) > -1)
        }
      }
      if (this.Declarant && this.coDeclarant.findIndex(p => p.id === this.Declarant) === -1) {
        this.Declarant = null
      }
      this.preselectTenantsOfApartment()
      return Promise.resolve(res)
    }).catch(error => Promise.reject(error))
  }

  async handleFetchBlocks(key: string, cb: Function) {
    const param: any = { key };
    return await this.storeGetBlocks({ param, merge: false }).then(res => {
      return res.map(x => ({ value: x.id, firstname: x.name, lastname: '', text: x.name })) || []
    })
  }

  handleGetApartments(key: string, cb) {
    let payload: any = { key, blockId: null }
    if (this.hadBlock && !this.dtExcludeBlock) {
      payload.blockId = this.FkTicketBlock
    }
    if (this.dtExcludeBlock) { payload.external = true }
    payload = this.fillPayloadEntityOwnerTenantForPrivateTicket(payload)
    //this.storeGetBlockApartmentsAutocomplete(payload)
    this.storeGetApartmentsAutocomplete(payload)
      .then(res => {
        //cb((res || []).map(x => ({value: x.apartment.id, text: x.apartment.apartment_number, ...x})))
        cb((res || []).map(x => ({ value: x.id, text: x.apartment_number, ...x })))
      })
      .catch(error => console.log(error))
  }

  async handleGetEquipments(key: string) {
    return this.getEquipmentByParams(false, key)
      .then(res => {
        return (res.data || []).map(x => ({ value: x.id, text: x.name, ...x }))
      })
      .catch(error => console.log(error))
  }

  handleFillZone() {
    if (this.hadApartment && this.$route.meta.apartment_zone_allowed) {
      let payload = { apartments: this.TicketApartments, q: '' }
      this.storeSearchApt(payload)
        .then(res => {
          this.dtZones = [...(res.data || []), ...(this.currentTicket.apartment_zone || [])]
        })
        .catch(error => console.log(error))
    } else {
      this.dtZones = []
    }
  }

  handleSearchZone(q: string, cb) {
    let payload = { apartments: this.TicketApartments, q }
    this.storeSearchApt(payload)
      .then(res => {
        cb((res.data || []).map(x => ({ value: x.id, text: x.name, ...x })))
      })
      .catch(error => console.log(error))
  }

  handleGetManagers(key: string) {
    return this.storeGetEntitySearch({
      entity: [SearchEntities.Manager],
      query: key,
      limit: 50
    })
  }

  async handlePbTypeChange(event) {
    /*if (this.$route.fullPath.indexOf('apartment') > -1 && event === TicketTypes.Private) {
      if (this.coTenants.length > 0) {
        //this.Tenants = this.coTenants[0].id
        this.Participants = this.coTenants
      }
    }*/
    if (!this.toUpdate) {
      await this.handleParticipantsDeclarantByBlockAndApartment()
      await this.handleApartmentByBlockAndEntities()
    }
  }

  checkUserTypePermission(type: string) {
    return type !== UserTypes.Tenant
      && type !== UserTypes.Owner;
  }

  fillPayloadEntityOwnerTenantForPrivateTicket(payload) {
    if (this.pbType === TicketTypes.Private
      || this.pbType === TicketTypes.Standard
      || this.pbType === TicketTypes.Anomaly
      || this.pbType === TicketTypes.Maintenance) {
      payload.entity = []
      // if Declarant is loc or prop
      const declarant = this.coDeclarant.find(x => x.id === this.Declarant);
      if (declarant && (declarant.type === SearchEntities.Tenant || declarant.type === SearchEntities.Owner)) {
        payload.entity = [this.Declarant]
      }
      //let participantsSelected = this.coParticipants.filter(participant => this.Participants.indexOf(participant.id) > -1)
      let participantsOwnerOrTenant = this.Participants.filter(participant => participant.type === SearchEntities.Tenant || participant.type === SearchEntities.Owner)
      if (participantsOwnerOrTenant.length > 0) {
        payload.entity = payload.entity.concat(participantsOwnerOrTenant.map(x => x.id))
      }
    }
    return payload
  }

  preselectTenantsOfApartment() {
    if (this.pbType === TicketTypes.Private && this.TicketApartments.length > 0) {
      let tenantsParticipant = this.dtTemporaryParticipants.filter(participant => participant.type === SearchEntities.Tenant)
      let tenantsToPreselect = tenantsParticipant.filter(tenant => (this.Participants.findIndex(x => x.id === tenant.id) === -1))
      if (tenantsToPreselect.length > 0) {
        this.Participants = this.Participants.concat(tenantsToPreselect)
      }
    }
  }

  removeDeclarantTenantOwner() {
    const declarant = this.coDeclarant.find(x => x.id === this.Declarant);
    if (declarant && (declarant.type === SearchEntities.Tenant || declarant.type === SearchEntities.Owner)) {
      this.Declarant = null
    }
  }

  pbTypeDefaultCase(key: string) {
    return this.ticketProblemType.map(x => x.key).indexOf(key) > -1
  }

  async getEquipmentByParams(resetEqp = true, key = null) {
    let params: any = {
      $limit: 50,
      block: this.FkTicketBlock
    }
    if (this.TicketApartments)
      params.apartment = this.TicketApartments
    if (this.FKTicketCharacterProblem)
      params.char1 = this.FKTicketCharacterProblem
    if (this.FKTicketCharacterProblem2)
      params.char2 = this.FKTicketCharacterProblem2
    if (resetEqp) {
      this.FKTicketEquipment = []
      this.dtEquipments = []
    }
    if (key) {
      params.q = key
    }
    if (this.$route.meta.select_ticket_equipment) {
      return this.storeGetEquipments(params)
    }
  }
}

export default TicketModalVertical;



// WEBPACK FOOTER //
// ./src/containers/ticket/components/ticket-modal-vertical/index.ts